import { render, staticRenderFns } from "./ico.vue?vue&type=template&id=17d43ef0&scoped=true&"
import script from "./ico.vue?vue&type=script&lang=js&"
export * from "./ico.vue?vue&type=script&lang=js&"
import style0 from "./ico.vue?vue&type=style&index=0&id=17d43ef0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d43ef0",
  null
  
)

export default component.exports